import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { faEye, faEdit, faRemove } from '@fortawesome/free-solid-svg-icons';
import { DealersService } from 'src/app/share/services/dealers/dealers.service';
import { Subscription } from 'rxjs';
import { MessageService } from 'src/app/share/sharedsubject';

@Component({
    selector: 'app-dealers-list',
    templateUrl: './dealers-list.component.html',
    styleUrls: ['./dealers-list.component.scss'],
    standalone: false
})
export class DealersListComponent implements OnInit, OnDestroy {
  protected readonly faEye = faEye; 
  protected readonly faEdit = faEdit; 
  protected readonly faRemove = faRemove; 
  dealersList: any[] = [];
  isToster: boolean = false;
  loader :boolean = false;
  errorMessage : any;
  message: any;
  subscription: Subscription;
  filters: any = { page: 0 };
  endOfResults: boolean = false;

  constructor(
    private readonly dealersService: DealersService,
    private readonly router: Router,
    private readonly messageService: MessageService
  )
  {
    this.subscription = this.messageService.getMessage().subscribe((message: any) => {
      if (message) {
        this.isToster = true;
        this.message = message.text;
      }
    });
  }

  ngOnInit(): void {
    this.getDealersList();
  }

  getDealersList(){
    this.loader = true;
    this.dealersService.getDealerDetails(this.filters).subscribe({
      next: (res:any) => {
      this.loader = false;
      const newData = res.data || [];
      this.dealersList = [...this.dealersList, ...newData]
      if (newData?.length == 0) this.endOfResults = true;
    },
      error: (error) => {
      this.errorMessage = error?.error?.error?.message;
      this.loader = false;
    }
    })
  }

  onScroll(){
    if (this.endOfResults || this.loader) return;
    this.filters.page++;
    this.getDealersList();
  }

  editBranch(dealerId:string){
   this.router.navigate(['/new-dealer'], {queryParams:{dId:dealerId}})
  }

  closeToster(event: any){
    this.isToster = false;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
